<template>
  <div id="app">
    <MeterPan></MeterPan>
  </div>
</template>

<script>
import MeterPan from "./components/MeterPan/MeterPan";

export default {
  name: 'App',
  components: {
    MeterPan
  }
}
</script>

<style>

</style>
